/** Business-dialect overrides. Sparse: a missing key falls back to en. */
export const project = {
    form: {
        deleteButton: 'Delete project',
        addTitle: 'Add Project',
        editTitle: 'Edit Project',
        nameLabel: 'Project name *',
        namePlaceholder: 'Acme Ltd Rebrand',
        customReferencePlaceholder: 'Acme Ltd / PRJ-2024-001',
        descriptionPlaceholder: 'Brief description of the project',
        nameRequired: 'Project name is required',
        createSubmit: 'Create project',
        updateSubmit: 'Save changes',
        createError: 'Failed to create project. Please try again.',
        updateError: 'Failed to update project. Please try again.',
    },
    summary: {
        sectionHeading: 'Project',
    },
    rate: {
        projectSummaryLabel: 'Your project rate',
        namedProjectSummaryLabel: '{{feeEarner}} project rate',
        feeEarnerLabel: 'Team member',
        rowsLabel: 'Team member rates',
        addRowLabel: 'Add team member rate',
        removeSharedFromClient: 'Remove the shared rate of {{rate}} from {{name}}? Team members without their own rate on this client then bill at their Team rate. Projects that have their own shared rate keep it.',
        removeSharedFromProject: "Remove the shared rate of {{rate}} from {{name}}? Team members with their own rate on this project or its client keep billing at it. Everyone else then bills at the client's shared rate if it has one, otherwise at their Team rate.",
    },
    selector: {
        searchPlaceholder: 'Search projects...',
        searchAriaLabel: 'Search projects',
        noActiveProjects: 'No active projects',
        couldNotLoad: 'Could not load projects',
        listboxAriaLabel: 'Projects',
        clearSelectionAriaLabel: 'Clear project selection',
    },
    list: {
        noFilterResults: 'No projects match your filters',
        heading: 'Projects',
        addButton: 'Add project',
        addFirstButton: 'Add first project',
        emptyStateForClient: 'No projects for {{clientName}}',
        columnHeader: 'Project',
        searchPlaceholder: 'Search projects...',
        searchAriaLabel: 'Search projects',
        noSearchResults: 'No projects match your search',
    },
    detail: {
        loading: 'Loading project...',
        loadError: "Couldn't load this project",
    },
    match: {
        addChipLabel: '+ Project',
        addAriaLabel: 'Match project',
        changeAriaLabel: 'Change matched project: {{name}}',
        removeAriaLabel: 'Remove project',
        noResultsForClient: 'No projects found for this client',
        reallocate: 'Reallocate to a different project',
    },
    matchReason: {
        referenceInEmail: 'Project reference appears in the email',
        nameInEmail: 'Project name appears in the email',
        threadInherited: 'An earlier email in this thread is allocated to this project',
        referenceClauseInEmail: 'project reference appears in the email',
        nameClauseInEmail: 'project name appears in the email',
        fuzzyClauseInEmail: 'the email closely matches this project',
        singleProjectClauseInEmail: 'this client has a single active project',
        similarEmailsFiled: 'Emails like this one were filed to this client before',
        recentMatterClauseInEmail: 'the project this client was most recently filed under',
        historyVoteClauseInEmail: 'similar emails were filed to this project before',
        referenceInEvent: 'Project reference appears in the event',
        nameInEvent: 'Project name appears in the event',
        fuzzyInEvent: 'Event details closely match this project',
        singleProjectInEvent: 'This client has a single active project',
    },
    archiveBanner: {
        heading: 'Project is archived',
        bodyForEmail: "The email stays linked for audit, but you can't log time against this project until it's restored.",
        bodyForEvent: "The event stays linked for audit, but you can't log time against this project until it's restored.",
    },
    noMatterHint: {
        forEmail: 'Pick a project to log activity for this email.',
        forEvent: 'Pick a project to log activity for this event.',
    },
    rejectDialog: {
        emailMessage: 'Archives the draft. The email stays linked to this project for audit - use the unlink action above to clear the link too.',
        eventMessage: 'The draft will be archived. The event stays linked to this project for audit - use the unlink action above to clear the link too.',
    },
    matchStatus: {
        draftDeletedForEvent: 'The draft was removed. This event is still linked to the project for audit. Remove the allocation to clear the link too.',
        draftDeletedForEmail: 'The draft was removed. This email is still linked to the project for audit. Remove the allocation to clear the link too.',
        noMatterSelectedHeadline: 'No project selected',
        noMatterSelectedForEvent: 'This event is linked to a client but not yet to a project. Choose a project to log time.',
        noMatterSelectedForEmail: 'This email is linked to a client but not yet to a project. Choose a project to log time.',
        noMatterMatchedHeadline: 'No project matched',
        noMatterMatchedExplanation: 'The matcher could not find a project for this event. Choose one above and log a draft if it represents billable work.',
        lowConfidenceExplanationForEvent: 'The project match was too uncertain to log automatically. Check the allocation and log a draft if it looks right.',
    },
    calendarActivityStatus: {
        noMatterSelected: 'No draft - no project selected',
        matterMatchNeedsReview: 'No draft - project match needs review',
    },
    pill: {
        archivedLabel: 'Project archived',
        archivedTitle: 'The project is archived. This entry stays linked for audit.',
    },
    filter: {
        label: 'Project',
        ariaLabel: 'project filter',
        allOption: 'All projects',
        clearUnmatchedHint: 'Clear Unmatched to filter by project',
    },
    expenseAttribution: {
        sectionHeading: 'Project',
        hint: "Link this expense to a project so it appears in that client's billable expenses when creating an invoice.",
        lockedPosted: 'This expense is approved, so its project is locked. To change it, void the expense and enter it again.',
        lockedBilled: 'This expense is billed to a client, so its project is locked.',
    },
    activitySearchPlaceholder: 'Search by description, project or client',
    activitySearchPlaceholderInClient: 'Search by description or project',
    reportFilter: {
        clearHint: 'Clear projects to filter by client.',
        loadError: 'Could not load projects. Please try again.',
        resolveError: 'Could not resolve selected project labels. Please try again.',
    },
    clientDeleteDialog: {
        message: "Delete {{name}}? Their projects are deleted too. They stay on past invoices but won't appear when adding new ones.",
    },
    csv: {
        nameHeaderRequired: 'Project Name*',
        referenceHeaderRequired: 'Project Reference*',
        referenceHeaderOptional: 'Project Reference',
    },
};
